import { init as initAnalytics } from './analytics.js';
import { init as initTheme } from './theme.js';
import { init as initNav } from './nav.js';
import { init as initReveal } from './reveal.js';
import { init as initCounters } from './counters.js';
import { init as initContactForm } from './contact-form.js';

document.addEventListener('DOMContentLoaded', () => {
  initAnalytics();
  initTheme();
  initNav();
  initReveal();
  initCounters();
  initContactForm();
});
